import { init, browserTracingIntegration, setTag, setUser } from '@sentry/browser'
import * as logger from '@mamdev/navigator.frontend-logger'
import { version } from '../../package.json'
import { getStage } from './stage'
import { getBrand } from './brand'
import { getTpid } from './tpid'
import { getAuthCase } from './auth-case'
import { getUrlParam } from './url-param'

export function isSentryLoaded(): boolean {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  return typeof (window as any).Sentry?.init === 'function';
}

export function initSentry(): void {
  const stage = getStage()
  const brand = getBrand()

  init({
    dsn: 'https://b1eb3d02ae2c954ac1a83e32bd2be636@trace-proxy.mam.dev/swat/19',
    environment: stage,
    release: `auth-intermediate@${version}`,
    integrations: [browserTracingIntegration()],
    tracesSampleRate: stage === 'live' ? 0.01 : 1.0,
    sampleRate: stage === 'live' ? 0.1 : 1.0,
  });
  setTag('brand', brand);
  setTag('config.has_navsid', (!!getUrlParam('navsid')));
  setTag('authCase', getAuthCase())
  setTag('section', getUrlParam('section') || 'unknown')
  const tpid = getTpid()
  if (tpid) {
    setUser({ id: tpid });
  }
  logger.registerAppender(logger.sentryAppender)
}
